import Auth from '@/models/Auth';

const itemHasOrganisation = item => {
    if (!('organisations' in item)) {
        return true;
    }

    const organisationType = Auth().organisation_type;

    if (!organisationType) {
        return false;
    }

    return item.organisations.some(type => type === organisationType);
};

export default itemHasOrganisation;
